import { ISubContentInfos } from 'src/models/management/business/SubContent';
import { separateFilesAndPaths } from 'src/utils/separateFilesAndPaths';

// 파일과 경로 분리를 처리하는 유틸 함수
export const processImagePaths = (
  currentPaths: Array<string | File>,
  originalPaths: string[] = [],
) => {
  const { files: uploadFiles, paths: existingPaths } = separateFilesAndPaths(currentPaths);
  const deletePaths = originalPaths.filter((path) => !existingPaths.includes(path));

  return { uploadFiles, existingPaths, deletePaths };
};

// 서브 컨텐츠 추가했을 때 이미지 처리 함수
export const processSubContentInfos = (
  subContentInfos: ISubContentInfos[] = [],
  originalSubContentInfos: ISubContentInfos[] = [],
) =>
  subContentInfos.map((info, index) => {
    const originalInfo = originalSubContentInfos[index] || {};

    const desktop = processImagePaths(
      info.desktopImagePath || [],
      originalInfo.desktopImagePath || [],
    );
    const mobile = processImagePaths(
      info.mobileImagePath || [],
      originalInfo.mobileImagePath || [],
    );

    return {
      ...info,
      ...(desktop.uploadFiles.length > 0 && { desktopFiles: desktop.uploadFiles }),
      ...(desktop.existingPaths.length > 0 && { desktopImagePath: desktop.existingPaths }),
      ...(desktop.deletePaths.length > 0 && { deleteDesktopPaths: desktop.deletePaths }),
      ...(mobile.uploadFiles.length > 0 && { mobileFiles: mobile.uploadFiles }),
      ...(mobile.existingPaths.length > 0 && { mobileImagePath: mobile.existingPaths }),
      ...(mobile.deletePaths.length > 0 && { deleteMobilePaths: mobile.deletePaths }),
    };
  });
